import { type Row } from "@tanstack/react-table";
import { useCallback } from "react";

export function useGetRowId(data: unknown[] | undefined) {
	return useCallback(
		function (_row: unknown, index: number, _parent: Row<unknown> | undefined) {
			//
			// Degenerate case. No data, id can be anything.
			//

			if (data === undefined) {
				return "-1";
			}

			//
			// Special case. If page size is infinite, we can use the index as the id.
			//

			return String(index);

			// if (data.pageSize === Infinity) {
			// 	return String(index);
			// }

			// //
			// // Normal case. Calculate absolute index from page, page size, and index. Use that as
			// // the id.
			// //

			// const paginatedIndex = (data.pageIndex || 0) * (data.pageSize || 0) + index;
			// const parentIndex = parent?.id;

			// const idComponents: (number | string)[] = [];
			// if (parentIndex) {
			// 	idComponents.push(parentIndex);
			// }
			// idComponents.push(paginatedIndex);
			// return idComponents.join(".");
		},
		[data]
	);
}
